import { emnus } from "./enums/Enums";

export function getEnumsOptions(key) {
    const data = emnus[key];
    if (!data) {
        return [];
    }
    return JSON.parse(JSON.stringify(data.options))
}

export function getEnumsOptionsWithAll(key) {
    const data = emnus[key];
    let options = []
    if (data && data.options) {
        options = JSON.parse(JSON.stringify(data.options))
    }
    options.unshift({
        value: '',
        label: '全部'
    })
    return options;
}

export function getEnumLabel(key, value) {
    const data = emnus[key];
    let options = []
    if (data && data.options) {
        options = JSON.parse(JSON.stringify(data.options))
    }
    if (!options) {
        return value
    }
    for (let i = 0; i < options.length; i++) {
        if (options[i].value === value) {
            return options[i].label
        }
    }
    return value;
}